module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/8ea006b5c59c10b0479ecaf812f13e44.png";